module.exports = __webpack_public_path__ + "static/media/DTD-2025-LOGO-White.34636abf.png";